import { render, staticRenderFns } from "./AsideMenuItem.vue?vue&type=template&id=35823ece&scoped=true&"
import script from "./AsideMenuItem.vue?vue&type=script&lang=js&"
export * from "./AsideMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./AsideMenuItem.vue?vue&type=style&index=0&id=35823ece&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35823ece",
  null
  
)

export default component.exports